import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import * as Styles from './Menu.styles';

export type MenuItemOptionsType = {
  warning?: boolean;
};

export type MenuItemProps = {
  menuItemIcon?: typeof MoreHorizIcon;
  label: string;
  callback: (event?: any) => void;
  menuItemOptions?: MenuItemOptionsType;
};

export type MenuProps = {
  icon: typeof MoreHorizIcon;
  menuId?: string;
  menuItems: MenuItemProps[];
  id: string;
  isShowingMenu: boolean;
  onToggleMenu: () => void;
  label?: string;
};

const Menu = ({
  icon: Icon,
  menuItems,
  menuId,
  id,
  isShowingMenu,
  onToggleMenu,
  label: buttonLabel,
  ...props
}: MenuProps): JSX.Element => {
  return (
    <Styles.Menu {...props} id={id}>
      <Styles.Button
        id={menuId}
        data-testid={`${menuId}-menu`}
        onClick={(event) => {
          event.stopPropagation();
          onToggleMenu();
        }}
        type="button"
      >
        {buttonLabel}
        <Icon sx={{ width: '12px' }} />
      </Styles.Button>
      {isShowingMenu && (
        <Styles.MenuItems>
          {menuItems.map(({ label, callback, menuItemIcon: MenuItemIcon, menuItemOptions }) => {
            const testId = `${menuId}-menu-item-${label?.replace(/\s/g, '-')?.toLowerCase()}`;
            return (
              <Styles.MenuItem
                key={label}
                data-testid={testId}
                onClick={(event) => {
                  callback(event);
                  onToggleMenu();
                }}
                type="button"
                {...menuItemOptions}
              >
                {MenuItemIcon && <MenuItemIcon sx={{ width: '12px' }} />}
                <Styles.Label>{label}</Styles.Label>
              </Styles.MenuItem>
            );
          })}
        </Styles.MenuItems>
      )}
    </Styles.Menu>
  );
};

export default Menu;
